export default __webpack_public_path__ + "static/media/Ballroll_00315.8714d67f.png";